// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_LangWrapper__NDOSn {
  width: 45px;
}
@media (max-width: 768px) {
  .style_LangWrapper__NDOSn {
    width: auto;
  }
}
.style_LangWrapper__NDOSn .style_MultiLang__TAA3R,
.style_LangWrapper__NDOSn .style_LangBtn__ZlIDS {
  padding: 5px 8px;
  background: rgba(255, 255, 255, 0.05);
  outline: none;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
}
@media (max-width: 768px) {
  .style_LangWrapper__NDOSn .style_MultiLang__TAA3R,
  .style_LangWrapper__NDOSn .style_LangBtn__ZlIDS {
    padding: 5px 6px;
  }
}
.style_LangWrapper__NDOSn .style_MultiLang__TAA3R.style_light__McNxx,
.style_LangWrapper__NDOSn .style_LangBtn__ZlIDS.style_light__McNxx {
  color: #fff;
  border: 1px solid #fff;
}
.style_LangWrapper__NDOSn .style_MultiLang__TAA3R.style_dark__Ay4uf,
.style_LangWrapper__NDOSn .style_LangBtn__ZlIDS.style_dark__Ay4uf {
  color: #000;
  border: 1px solid #000;
}
.style_LangWrapper__NDOSn .style_MultiLang__TAA3R.style_dark__Ay4uf svg path,
.style_LangWrapper__NDOSn .style_LangBtn__ZlIDS.style_dark__Ay4uf svg path {
  stroke: #000;
}
.style_LangWrapper__NDOSn li {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: var(--light-color);
  text-transform: uppercase;
  margin-bottom: 8px;
}
.style_LangWrapper__NDOSn button {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: var(--light-color);
  text-transform: uppercase;
}
.style_LangWrapper__NDOSn .style_MultiLang__TAA3R {
  position: absolute;
  top: 32px;
  left: 65%;
  transform: translateX(-50%);
  width: 100%;
  border-top: none;
  background: rgba(255, 255, 255, 0.05);
  padding: 8px 28px 0px;
}
@media (max-width: 768px) {
  .style_LangWrapper__NDOSn .style_MultiLang__TAA3R {
    left: 50%;
  }
}
.style_LangWrapper__NDOSn .style_MultiLang__TAA3R li {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/header/langSelect/style.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAKE;EAPF;IAQI,WAAA;EAFF;AACF;AAGE;;EAEE,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AADJ;AAGI;EATF;;IAUI,gBAAA;EACJ;AACF;AAAI;;EACE,WAAA;EACA,sBAAA;AAGN;AADI;;EACE,WAAA;EACA,sBAAA;AAIN;AAFQ;;EACE,YAAA;AAKV;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;AACJ;AAEE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EAGA,gBAAA;EACA,qCAAA;EACA,qBAAA;AAFJ;AAII;EAZF;IAaI,SAAA;EADJ;AACF;AAEI;EACE,aAAA;EACA,uBAAA;AAAN","sourcesContent":[".LangWrapper {\n  width: 45px;\n  // height: 28px;\n  // @media (max-width: 1024px) {\n  // margin-top: 50px;\n  // }\n\n  @media (max-width: 768px) {\n    width: auto;\n  }\n  .MultiLang,\n  .LangBtn {\n    padding: 5px 8px;\n    background: rgba(255, 255, 255, 0.05);\n    outline: none;\n    text-align: center;\n    cursor: pointer;\n    border-radius: 8px;\n    // height: 28px;\n    @media (max-width: 768px) {\n      padding: 5px 6px;\n    }\n    &.light {\n      color: #fff;\n      border: 1px solid #fff;\n    }\n    &.dark {\n      color: #000;\n      border: 1px solid #000;\n      svg {\n        path {\n          stroke: #000;\n        }\n      }\n    }\n  }\n\n  li {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    color: var(--light-color);\n    text-transform: uppercase;\n    margin-bottom: 8px;\n  }\n  button {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px;\n    color: var(--light-color);\n    text-transform: uppercase;\n  }\n\n  .MultiLang {\n    position: absolute;\n    top: 32px;\n    left: 65%;\n    transform: translateX(-50%);\n    width: 100%;\n    // border-top-left-radius: 0;\n    // border-top-right-radius: 0;\n    border-top: none;\n    background: rgba(255, 255, 255, 0.05);\n    padding: 8px 28px 0px;\n\n    @media (max-width: 768px) {\n      left: 50%;\n    }\n    li {\n      display: flex;\n      justify-content: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"LangWrapper": `style_LangWrapper__NDOSn`,
	"MultiLang": `style_MultiLang__TAA3R`,
	"LangBtn": `style_LangBtn__ZlIDS`,
	"light": `style_light__McNxx`,
	"dark": `style_dark__Ay4uf`
};
export default ___CSS_LOADER_EXPORT___;
